import React from 'react';

// === Authentication & Error Pages ===
export const InvalidRolePage = React.lazy(() =>
  import('@/pages/invalid-role/invalid-role.page').then((m) => ({
    default: m.InvalidRolePage,
  })),
);

export const RedirectPage = React.lazy(() =>
  import('@/pages/redirect/redirect.page').then((m) => ({
    default: m.RedirectPage,
  })),
);

// === Consumer Pages - Products ===
export const ProductGroupsPage = React.lazy(() =>
  import('@/pages/product-groups/product-groups.page').then((m) => ({
    default: m.ProductGroupsPage,
  })),
);

export const ProductsPage = React.lazy(() =>
  import('@/pages/products/all/products.page').then((m) => ({
    default: m.ProductsPage,
  })),
);

export const PreTailoringPage = React.lazy(() =>
  import('@/pages/products/pre-tailoring/pre-tailoring.page').then((m) => ({
    default: m.PreTailoringPage,
  })),
);

export const TailoringPage = React.lazy(() =>
  import('@/pages/products/tailoring/tailoring.page').then((m) => ({
    default: m.TailoringPage,
  })),
);

export const SummaryPage = React.lazy(() =>
  import('@/pages/products/summary/summary.page').then((m) => ({
    default: m.SummaryPage,
  })),
);

export const DataPage = React.lazy(() =>
  import('@/pages/data/data.page').then((m) => ({
    default: m.DataPage,
  })),
);

export const ExportPage = React.lazy(() =>
  import('@/pages/export/export.page').then((m) => ({
    default: m.ExportPage,
  })),
);

// === Consumer Pages - Templates ===
export const TemplatesPage = React.lazy(() =>
  import('@/pages/templates/all/templates.page').then((m) => ({
    default: m.TemplatesPage,
  })),
);

export const TemplatesPretailoringPage = React.lazy(() =>
  import('@/pages/templates/pre-tailoring/templates-pre-tailoring.page').then((m) => ({
    default: m.TemplatesPretailoringPage,
  })),
);

export const TemplatesTailoringPage = React.lazy(() =>
  import('@/pages/templates/tailoring/templates-tailoring.page').then((m) => ({
    default: m.TemplatesTailoringPage,
  })),
);

// === Consumer Pages - Updates ===
export const UpdateSingleItemPage = React.lazy(() =>
  import('@/pages/update/single/update-single-item.page').then((m) => ({
    default: m.UpdateSingleItemPage,
  })),
);

export const UpdateAllPage = React.lazy(() =>
  import('@/pages/update/all/update-all.page').then((m) => ({
    default: m.UpdateAllPage,
  })),
);

// === Consumer Pages - Substitution ===
export const ManageSubstitutionsPage = React.lazy(() =>
  import('@/pages/manage-substitutions/manage-substitutions.page').then((m) => ({
    default: m.ManageSubstitutionsPage,
  })),
);

// === Maintainer Pages ===
export const BulkUploadPage = React.lazy(() =>
  import('@/pages/bulk-upload/bulk-upload.page').then((m) => ({
    default: m.BulkUploadPage,
  })),
);

export const MaintainerHomePage = React.lazy(() =>
  import('@/pages/maintainer/home/maintainer.home.page').then((m) => ({
    default: m.MaintainerHomePage,
  })),
);

export const MaintainerViewEditNodePage = React.lazy(() =>
  import('@/pages/maintainer/view-edit-node/maintainer.view-edit-node.page').then((m) => ({
    default: m.MaintainerViewEditNodePage,
  })),
);

export const MaintainerPublishNodePage = React.lazy(() =>
  import('@/pages/maintainer/publish-node/maintainer.publishing.page').then((m) => ({
    default: m.MaintainerPublishNodePage,
  })),
);

// === Developer Pages ===
export const DevPage = React.lazy(() =>
  import('@/pages/dev/dev.page').then((m) => ({
    default: m.DevPage,
  })),
);
